import { Component, OnInit } from "@angular/core";
import { REPORTS_SCREEN_TYPE_ENUM } from "../shared/models/invoices.model";
import { Store } from "@ngrx/store";
import { currentReportScreenType } from "../shared/ngrx/ngrx-selectors";
import { ReportFiltersComponent } from "./report-filters/report-filters.component";
import { CommonModule } from "@angular/common";
import { ModalPopupComponent } from "../shared/components/ui/modal-popup.component";
import { PdfPreviewComponent } from "./pdf-preview/pdf-preview.component";
import { BalanceComponent } from "./balance/balance.component";
import { InvoicesComponent } from "./invoices/invoices.component";
import { ReceiptsComponent } from "./receipts/receipts.component";

@Component({
  selector: "reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.sass"],
  standalone: true,
  imports: [
    CommonModule,
    ModalPopupComponent,
    PdfPreviewComponent,
    BalanceComponent,
    ReportFiltersComponent,
    InvoicesComponent,
    ReceiptsComponent,
  ],
})
export class ReportsComponent implements OnInit {
  displayDocPdf: boolean;
  docPdfUrl: string;
  docNum: number;
  docTitle: string;

  constructor(private readonly store: Store) {}

  get displayInvoices(): boolean {
    return (
      this.store.selectSignal(currentReportScreenType)() ==
      REPORTS_SCREEN_TYPE_ENUM.INVOICES
    );
  }
  get displayReceipts(): boolean {
    return (
      this.store.selectSignal(currentReportScreenType)() ==
      REPORTS_SCREEN_TYPE_ENUM.RECEIPTS
    );
  }
  get displayBalance(): boolean {
    return (
      this.store.selectSignal(currentReportScreenType)() ==
      REPORTS_SCREEN_TYPE_ENUM.BALANCE
    );
  }

  ngOnInit(): void {}

  onDocPdfOpen(event: any) {
    this.docPdfUrl = event.url;
    this.docNum = event.docNum;
    this.docTitle = event.docTitle;
    this.displayDocPdf = true;
  }
}
